import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApi } from "../../../utlis/axios";
import styles from "./timesheet.module.css";
import Loader from "../../Loader/Loader";
import { FaCheck, FaAngleDown, FaAngleRight, FaRegCheckCircle } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import { MdOutlineDeleteOutline } from "react-icons/md";
import {IoSearch} from 'react-icons/io5'
import loader from '../../../assets/loading-gif.gif'
import { addToast } from "../../../Redux/Slices/toast-slice"; 
import { IoMdTime } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaSortAmountDown } from "react-icons/fa";

const AdminTimeSheet = () => {
  const { userInfo } = useSelector((state) => state.auth || {});
  const { theme } = useSelector((state) => state.theme);
  const dispatch=useDispatch()
  const [timeSheetsData, setTimesheetsData] = useState([]);
  const [dataWithoutSearches, setDataWithoutSearches] = useState([]);
  const [otsData, setOTSData] = useState([]);
  const [next, setNext] = useState(null);
  const [prev, setPrev] = useState(null);
  const [expandedRow, setExpandedRow] = useState("");
  const [loading, setLooading] = useState(false);
  const [activeTab, setActiveTab] = useState("pending");
  const [searchTerm, setSearchTerm] = useState("");
  const [searching, setSearching]=useState(false);
  const [rejectingStates, setRejectStates] = useState({})
  const [approvingStates, setApprovingStates] = useState({});
  const [deletingStates, setDeletingStates] = useState({})
   const [sortingDropDownOpen, setSortingDropDownOpen] = useState(false);
    const sortingdropdownRef = useRef(null)
    const [selectedSort, setSelectedSort] = useState('random')
  
    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (sortingdropdownRef.current && !sortingdropdownRef.current.contains(event.target)) {
          setSortingDropDownOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  const getAllTimeSheet = async () => {
    setLooading(true);
    try {
      const url=activeTab === 'pending' ? 'company-user-invoices/?is_approved=false' : 'company-user-invoices/?is_approved=true'
      const res = await fetchApi.get(url, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setOTSData(res.data.results);
        setDataWithoutSearches(res.data.results);
        setNext(res.data.next);
        setPrev(res.data.previous);
      }
    } catch (error) {
      dispatch(addToast({ message:error.message, type:'error' })); 
    } finally {
      setLooading(false);
    }
  };

  useEffect(() => {
    getAllTimeSheet();
  }, [activeTab]);

  const handlePageChange = async (url) => {
    setLooading(true);
    try {
      const res = await fetchApi.get(`${url}`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setDataWithoutSearches(res.data.results);
        setOTSData(res.data.results);
        setNext(res.data.next);
        setPrev(res.data.previous);
      }
    } catch (error) {
      dispatch(addToast({ message:error.message, type:'error' })); 
    } finally {
      setLooading(false);
    }
  };
  const updateTimeSheet = async () => {
    try {
      const url=activeTab === 'pending' ? 'company-user-invoices/?is_approved=false' : 'company-user-invoices/?is_approved=true'
      const res = await fetchApi.get(url, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setOTSData(res.data.results);
        setDataWithoutSearches(res.data.results);
        setNext(res.data.next);
        setPrev(res.data.previous);
      }
    } catch (error) {
      dispatch(addToast({ message:error.message, type:'error' })); 
    }
  };
  const handleApprove = async (id) => {
    setApprovingStates((state)=> ({...state, [id]:true}))
    try {
      const res = await fetchApi.patch(
        `company-user-invoices/${id}/`,
        { is_approved: true },
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 200) {
        dispatch(addToast({ message:"Approved successfully", type:'success' })); 
        updateTimeSheet();
      }
    } catch (error) {
      dispatch(addToast({ message:error.message, type:'error' })); 
    }
    setApprovingStates((prev) => ({ ...prev, [id]: false })); 
  };
  const handleDelete = async (id) => {
    setDeletingStates((state)=> ({...state, [id]:true}))
// Optimistically remove item

    try {
        const res = await fetchApi.delete(`company-user-invoices/${id}/`, {
            headers: {
                Authorization: `Bearer ${userInfo.access_token}`,
            },
        });
        setOTSData(prev => prev.filter(item => item.id !== id)); 
        updateTimeSheet(); // Refresh data
    } catch (error) {
        dispatch(addToast({ message: error.message, type: "error" }));
    }finally{
      setDeletingStates((state)=> ({...state, [id]:false}))
    }
};

  const handleSearch = async () => {
   if(!searchTerm){
    dispatch(addToast({ message:"Please enter search query", type:'warn' })); 
   }else{
    setSearching(true)
    try {
    const res = await fetchApi.get(`company-user-invoices/?search=${searchTerm}&status=${activeTab}`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setOTSData(res.data.results);
        setNext(res.data.next);
        setPrev(res.data.previous);
      }
    } catch (error) {
      dispatch(addToast({ message:error.message, type:'error' })); 
    }finally{
      setSearching(false)
    }
   }
  };
  const toggleRow = (index) => {
    setExpandedRow((prevIndex) => (prevIndex === index ? null : index));
  };
  const getTabStyles = (tabName) => {
    const isActive = activeTab === tabName;
   const activeColor = ' bg-gradient-to-r from-[#CC0927] to-[#7E0105] text-white'
    const inactiveColor =
      theme === "dark"
        ? "bg-transparent text-white"
        : "bg-transparent text-gray-600";

    return `w-1/2 text-center outline-none py-2 font-medium transition-colors duration-300 ${
      isActive ? activeColor : inactiveColor
    }`;
  };

  useEffect(() => {
    if (activeTab === "pending") {
      setTimesheetsData(otsData.filter((data) => data.is_approved === false));
    } else {
      setTimesheetsData(otsData.filter((data) => data.is_approved === true));
    }
  },[activeTab,otsData]);

  return (
    <div className=" h-full flex flex-col items-center w-full ">
      {loading && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-10 md:top-[95px] top-[52px]"
          ></div>
          <div
            className="fixed inset-0 flex items-center justify-center z-20 
           md:top-[95px] top-[52px]" 
          >
            <Loader />
          </div>
        </>
      )}
       <div className="my-6 md:px-6 px-2 w-full">
        <h1 className={`text-[26px] font-medium ${theme === 'dark' ? 'text-white' : 'text-black'}`}>User Timesheets</h1>
      </div>
      <hr className="w-full" />
      <div className="mt-8 md:px-8 px-2 flex flex-col items-center w-full">
        <div className="w-full max-w-screen-lg ">
          {" "}
        
          <div className="mt-2 mb-3 flex sm:flex-row flex-col justify-between items-center gap-4">
            <div className="flex gap-2 sm:w-max w-full items-center justify-between sm:justify-center">
            <div
              className={`py-2 px-3 justify-between flex gap-2 md:64 outline-none border rounded-[22px] ${theme === 'dark' ? 'bg-[#212529] border-[#555657] text-white' : "bg-[#F2F4F7] border-[#9A9FA5] text-black"}`}
            >
              {!searching ? 
              <IoSearch
                className="w-6 h-6 cursor-pointer"
                onClick={handleSearch}
              /> : <img src={loader} alt="Loading..." className="w-6 h-6"/>}
              <input
                type="text"
                value={searchTerm}
                placeholder="Search here..."
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  if (!e.target.value) {
                    setOTSData(dataWithoutSearches);
                    setNext(null);
                    setPrev(null);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                className="px-1 w-[87%] bg-transparent outline-none"
              />
            </div>
            <div className="relative fontRoboto " ref={sortingdropdownRef}>
                  {/* Dropdown Toggle Button */}
                  <button
                    className={`flex items-center p-2 justify-center border rounded-[10px] ${theme === "dark"
                      ? "bg-[#212529] border-[#555657] text-white"
                      : "bg-[#F2F4F7] border-[#9A9FA5] text-black"
                      }`}
                    onClick={() => setSortingDropDownOpen(!sortingDropDownOpen)}
                  >
                    <FaSortAmountDown className="w-5 h-5 cursor-pointer" />
                  </button>

                  {/* Dropdown Menu */}
                  {sortingDropDownOpen && (
                    <div
                      className={`absolute top-12 right-0 w-48 p-3 rounded-[10px] shadow-lg border z-[50] ${theme === "dark"
                        ? "bg-[#212529] border-[#555657] text-white"
                        : "bg-white border-[#9A9FA5] text-black"
                        }`}
                    >
                      <h3 className="text-lg font-medium mb-2">Sort by Date:</h3>
                      <div className="space-y-2">
                        {["Oldest to Newest", "Newest to oldest", "Random"].map((option) => (
                          <label
                            key={option}
                            className={`flex items-center space-x-2 cursor-pointer `}
                          >
                            <input
                              type="radio"
                              name="sort"
                              value={option}
                              checked={selectedSort === option}
                              onChange={() => setSelectedSort(option)}
                              className="hidden"
                            />
                            <span
                              className={`w-4 h-4 border rounded-full flex items-center justify-center ${selectedSort === option ? "border-[#CC0927]" : "border-gray-500"
                                }`}
                            >
                              {selectedSort === option && (
                                <span className="w-2.5 h-2.5 bg-[#CC0927] rounded-full"></span>
                              )}
                            </span>
                            <span className="text-base font-normal">{option}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
            </div>
            <div
            className={`flex px-[2px] py-[2px] justify-between items-center rounded-[22px] border ${theme === 'dark' ? 'bg-[#212529] border-[#555657] text-white' : "bg-[#F2F4F7] border-[#9A9FA5] text-black"}`}
          >
            <button
              className={`${getTabStyles("pending")} rounded-[22px] flex gap-2 items-center px-4`}
              onClick={() => setActiveTab("pending")}
            >
            <IoMdTime className="w-6 h-6"/>
              Pending
            </button>
            <button
              className={`${getTabStyles("approved")} rounded-[22px] flex items-center px-4 gap-2`}
              onClick={() => setActiveTab("approved")}
            >
              <FaRegCheckCircle className="w-6 h-6"/>
              Approved
            </button>
          </div>
          </div>
          <div className={`${styles.tableResponsive} max-w-screen-lg mt-4`} style={{overflowX: 'auto'}}>
            <table
              className={`${theme === "dark" ? "text-white" : "text-black"} ${
                styles.table
              }`}
            >
              <thead className={`bg-[#CE0927] text-white`}>
                <tr>
                  <th>Title</th>
                  <th>Amount</th>
                  <th>OverTime Amount</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {timeSheetsData.length > 0 ? (
                  (
                    selectedSort === 'Newest to oldest'
                      ? [...timeSheetsData].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                      : selectedSort === 'Oldest to Newest'
                        ? [...timeSheetsData].sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                        : timeSheetsData)?.map((item, i) => (
                    <>
                      <tr
                        key={i}
                        className={` ${
                          theme === "dark"
                            ? "hover:bg-gradient-to-r from-[#fff3] to-[#fff0]"
                            : "hover:bg-gradient-to-r from-[#6d6d6d33] to-[#fff0]"
                        }
                        ${i % 2 !== 0 ? theme === 'dark' ? 'bg-[#5565571A]' : 'bg-[#F5F6FA]' : ''}
                    `}
                      >
                        <td
                          style={{ borderBottom: "none" }}
                          onClick={() => toggleRow(i)}
                          className="cursor-pointer flex gap-1 items-center"
                        >
                          {expandedRow === i ? (
                            <FaAngleDown />
                          ) : (
                            <FaAngleRight />
                          )}
                          {item.title}
                        </td>
                        <td style={{ borderBottom: "none" }}>{item.amount}</td>
                        <td style={{ borderBottom: "none" }}>
                          {item.overtime_amount}
                        </td>
                        <td style={{ borderBottom: "none" }}>
                          {item.total_amount}
                        </td>
                        <td style={{ borderBottom: "none" }}>
                          {item?.is_approved ? (
                            <span className="border-2 border-green-600 text-green-600 font-medium  h-[30px] w-[80px] flex rounded-[20px] justify-center items-center">
                              Approved
                            </span>
                          ) : (
                            <span className="border-2 border-[#CA8A04] text-[#CA8A04] font-medium  h-[30px] w-[80px] flex rounded-[20px] justify-center items-center">
                              Pending
                            </span>
                          )}
                        </td>
                        <td style={{ borderBottom: "none" }}>
                          {item.is_approved ? (
                            <Tooltip title="Delete" arrow placement="top">
                              <button
                                className="cursor-pointer outline-none"
                                onClick={() => handleDelete(item.id)} disabled={deletingStates[item.id]}
                              >
                               {deletingStates[item.id] ? <img src={loader} alt="loadin" className="w-5 h-5" /> : <RiDeleteBin6Line className="w-6 h-6 cursor-pointer" />}
                              </button>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Approve" arrow placement="top">
                              <button
                                className="cursor-pointer outline-none"
                                disabled={approvingStates[item.id]}
                                onClick={() => handleApprove(item.id)}
                              >
                                {approvingStates[item.id] ? <div className="w-7 h-7 justify-center items-center flex"><img src={loader} alt="loader" className="w-5 h-5" /></div> :
                                <FaRegCheckCircle className="w-6 h-6" /> }
                              </button>
                            </Tooltip>
                          )}
                        </td>
                      </tr>
                      {expandedRow === i && (
                        <tr>
                          <td
                            colSpan={6}
                            className={`p-4 ${
                              theme === "dark"
                                ? " text-white bg-gradient-to-r from-[#fff3] to-[#fff0]"
                                : " text-black bg-gradient-to-r from-[#6d6d6d33] to-[#fff0]"
                            }`}
                          >
                            <div className={` p-4 rounded`}>
                              <strong>Full Description:</strong>{" "}
                              {item.description}
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))
                ) : (
                  <tr className="flex m-2">
                    No data found
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="w-full  my-2 justify-between flex">
            <span>
              {prev && (
                <button
                  className="heroButton block"
                  onClick={() => handlePageChange(prev)}
                >
                  Previous
                </button>
              )}
            </span>
            <span>
              {next && (
                <button
                  className="heroButton block"
                  onClick={() => handlePageChange(next)}
                >
                  Next
                </button>
              )}
            </span>
          </div>
        </div>
        </div>
    </div>
  );
};

export default AdminTimeSheet;
